import { isEmpty } from 'lodash';
import moment from 'moment';

const getHelpRequestStatusResponse = (data) => {
  if (isEmpty(data)) return {};

  const requestTime = data?.requestTime;

  const target = moment(requestTime);
  const now = moment();
  const cancelDuration = now.diff(target, 'seconds');

  return { ...data, cancelDuration };
};

export default getHelpRequestStatusResponse;
